import React, {useEffect, useState} from 'react';
import {Button, Form, Input, InputNumber, notification} from 'antd';
import Axios from "../../config/axiosConfig/axios";
import {Api} from "../../config/apiList/api";

const layout = {
    labelCol: {
        span: 4,
    },
    wrapperCol: {
        span: 10,
    },
};

const OperatorForm = (props) => {

    const [step, setStep] = useState(0);


    const onFinish = async (values) => {
        const data = {
            userName: values.userName,
            password: values.password,
            mobile: values.mobile
        }

        await Axios.post("",`${Api}create-operator-panel`, data
        )
            .then(async (data) => {
                if (data.statusCode === 200 || data.statusCode === 201) {
                    await notification.open({
                        message: "موفقیت",
                        description: "درخواست با موفقیت انجام شد!",
                        style: {
                            background: "#43a047",
                            color: "white",
                            fontFamily: "IRANSansMobileFaNum",
                            borderRadius: "5px",
                        }
                    })
                    await Axios.get(`${Api}operator-list-panel?page=${props.pageNumber}`
                    )
                        .then((data) => {
                            if (data.statusCode === 200 || data.statusCode === 201) {
                                props.setOperatorList(data.data.data);
                            }

                        })
                        .catch((error) => {
                        });

                    await props.setStep(1);

                }
                else {
                    notification.error({
                        message: "اخطار",
                        description: data.message,
                        placement: "topRight",
                        closeIcon: <p/>,
                        duration: 2
                    });
                }


            })
            .catch((error) => {
            });
    };

    const onCancel = () =>{
        props.setStep(1);
    }


    return <Form {...layout} name="nest-messages" onFinish={onFinish} >
        <Form.Item requiredMark={"optional"}
                   name="userName"
                   label={<p style={{fontSize: "18px", fontFamily: "iranSansBold"}}>نام کاربری</p>}
                   rules={[
                       {
                           required: true,
                           message: "نام کاربری باید بیشتر از 5 کاراکتر باشد!",
                           min: 5
                       },
                   ]}
        >
            <Input />
        </Form.Item>
        <Form.Item
            name="mobile"
            label={<p style={{fontSize: "18px", fontFamily: "iranSansBold", marginRight: "11px"}}>موبایل</p>}
            rules={[
                {
                    required: false,
                    message: "شماره موبایل باید 11 رقم باشد!",
                    min: 11,
                    max: 11

                },
                ({ getFieldValue }) => ({
                    validator(_, value) {
                        if (!value || (value.startsWith("09")) || !isNaN(value) ) {
                            return Promise.resolve();
                        }
                        return Promise.reject(new Error("شماره موبایل باید با 09 شروع شود!"));
                    },
                }),
            ]}
        >
            <Input style={{fontFamily: "iranSansBold"}}/>
        </Form.Item>

        <Form.Item requiredMark={"optional"}
                   name="password"
                   label={<p style={{fontSize: "18px", fontFamily: "iranSansBold", marginRight: "10px"}}>رمز</p>}
                   rules={[
                       {
                           required: true,
                           message: "رمز باید بیشتر از 8 کاراکتر باشد!",
                           min: 8
                       },
                   ]}
        >
            <Input type={"password"}/>
        </Form.Item>

        <Form.Item requiredMark={"optional"}
                   name="password2"
                   label={<p style={{fontSize: "18px", fontFamily: "iranSansBold"}}>تکرار رمز</p>}
                   rules={[
                       {
                           required: true,
                           message: "تکرار رمز الزامی است",
                       },
                       ({ getFieldValue }) => ({
                           validator(_, value) {
                               if (!value || getFieldValue('password') === value) {
                                   return Promise.resolve();
                               }
                               return Promise.reject(new Error("رمز های ورودی یکسان نیست!"));
                           },
                       }),
                   ]}
        >
            <Input type={"password"} />
        </Form.Item>

        <Form.Item>

            <Button style={{marginRight: "178px", marginTop: "20px", fontFamily: "iranSansBold"}} onClick={onCancel}>
                انصراف
            </Button>

            <Button type="primary" htmlType={"submit"} style={{marginRight: "20px", fontSize: "15px", fontFamily: "iranSansBold"}} >
                تایید
            </Button>


        </Form.Item>
    </Form>

};
export default OperatorForm;